import React, { useContext } from "react"
import { DiscList, InlineLink } from "../../components/auvelity-ui"
import tw from "twin.macro"
import createModal from "../../components/modals/createModal"
import useScrollbarSize from "react-scrollbar-size"
import { myContext } from "../../context/Provider"
const Section = tw.div`mt-5 text-black md:(text-base)`
const Semibold = tw.span`font-semibold text-blue md:(text-base)`
const BlackHeading = tw`text-black`

export const Heading = tw.div`font-bold text-blue my-2 uppercase text-lg`

export const ISIIndication = ({ isStatic, hideHeader, hideHeaderMobile }) => {
  const context = useContext(myContext)
  // console.log("context", context)
  return (
    <>
      {!hideHeader && isStatic && (
        <div tw="font-bold text-blue my-2 uppercase text-lg" className="hide-full hide-full-header">
          WHAT IS AUVELITY?
        </div>
      )}
      {(hideHeader && !isStatic || context.isMobile && !isStatic) && (
        <>
        <div css={[isStatic && tw`mb-5`, tw`mt-0`]} className="hide-full">
          It is a prescription oral medicine used to treat adults with major depressive disorder (MDD). It is not known if AUVELITY is safe and effective for use in children.
        </div>
        <div css={[isStatic && tw`mb-5`, tw`mt-0`]} className="hide-full">
          AUVELITY is not approved for uses other than the treatment of MDD. The ingredients in AUVELITY, bupropion and dextromethorphan, are the same ingredients found in some other medicines approved for other uses.
        </div>
        </>
      )}
    </>
  )
}

export const ISISafety = ({ removeTabIndex, isStatic, hideHeader }) => {
  const { width } = useScrollbarSize()
  const createExitModal = e => {
    e.preventDefault()
    createModal({
      modalType: "exit",
      yesLink: "http://www.fda.gov/medwatch",
      addClassForGTM: "fl-exit-medwatch",
      modalName: "Med Watch",
      scrollWidth: width,
    })
  }
  return (
    <>
      {isStatic && (
        <Heading css={[tw`mt-4 lg:mt-6`, isStatic && tw`mt-6 lg:mt-6`]}>
          WHAT IS THE MOST IMPORTANT INFORMATION I SHOULD KNOW ABOUT AUVELITY?
        </Heading>
      )}
      <Section css={[isStatic && tw`mb-0`, tw`mt-0`]}>
        <Semibold css={[BlackHeading]}>
        AUVELITY (aw-VEHL-ah-tee)  and other antidepressant medicines may increase suicidal thoughts and actions in some children, adolescents, and young adults, especially within the first few months of treatment or when the dose is changed. AUVELITY is not for use in children.
        </Semibold>
      </Section>
      <Section>
      You should pay close attention to any new or sudden changes in mood, behavior, thoughts, or feelings or if you develop suicidal thoughts or actions. This is very important when starting or changing the dose of an antidepressant medicine.
      </Section>
      <Section>
        <p>
          <Semibold>
          Call your healthcare provider (HCP) or get emergency help right away if you or your loved one have any of the following symptoms, especially if they are new, worse, or worry you:
          </Semibold>
        </p>
      </Section>
      <Section tw="flex flex-col mt-2 md:(flex-row)">
        <DiscList isi={true} tw="mr-10">
          <li>suicidal thoughts or actions</li>
          <li>new or worsening depression or anxiety</li>
          <li>agitation or restlessness</li>
          <li>trouble sleeping (insomnia)</li>
          <li>acting aggressive, being angry, or violent</li>
        </DiscList>
        <DiscList isi={true}>
          <li>an extreme increase in activity and talking&nbsp;(mania)</li>
          <li>panic attacks</li>
          <li>new or worsening irritability</li>
          <li>acting on dangerous impulses</li>
          <li>other unusual changes in behavior or mood</li>
        </DiscList>
      </Section>
      <Heading tw="mt-8">
        WHAT IS AUVELITY?
      </Heading>
      <Section css={[isStatic && tw`mb-0`, tw`mt-0`]}>
      It is a prescription oral medicine used to treat adults with major depressive disorder (MDD). It is not known if AUVELITY is safe and effective for use in children.
      </Section>
      <Section css={[isStatic && tw`mb-5`, tw`mt-0`]}>
        AUVELITY is not approved for uses other than the treatment of MDD. The ingredients in AUVELITY, bupropion and dextromethorphan, are the same ingredients found in some other medicines approved for other uses.
        <Heading tw="mt-8">
          WHAT IS THE MOST IMPORTANT INFORMATION I SHOULD KNOW ABOUT AUVELITY? (CONT'D)
        </Heading>
        <div tw="mb-1">
          <Semibold>Do not take AUVELITY if you:</Semibold>
        </div>
        <DiscList isi={true}>
          <li>have or had a seizure disorder.</li>
          <li>have or had an eating disorder like anorexia or bulimia.</li>
          <li>have recently and suddenly stopped drinking alcohol or use medicines called benzodiazepines, barbiturates, or anti-seizure medicines, and you have recently suddenly stopped taking them.</li>
          <li>are taking a monoamine oxidase inhibitor (MAOI), have stopped taking an MAOI in the last 14 days, or are being treated with the antibiotic linezolid or intravenous methylene blue. Ask your HCP or pharmacist if you are unsure whether you take an MAOI. Do not start taking an MAOI until you have stopped taking AUVELITY for at least 14 days.</li>
          <li>are allergic to dextromethorphan, bupropion, or any other ingredients in AUVELITY.</li>
        </DiscList>
      </Section>
      <Section>
        <Semibold>
        AUVELITY may cause serious side effects. Ask your HCP how to recognize the serious side effects below and what to do if you think you have one:
        </Semibold>
      </Section>
      <Section tw="mt-2">
        <Semibold>Seizures.</Semibold> There is a risk of seizures during treatment with AUVELITY. The risk is higher if you take higher doses of AUVELITY, have certain medical problems, or take AUVELITY with certain other medicines. <strong>Do not</strong> take AUVELITY with other medicines unless your healthcare provider tells you to.
      </Section>
      <Section>If you have a seizure during treatment with AUVELITY, stop taking AUVELITY and call your HCP right away. <strong>Do not</strong> take AUVELITY again if you have a seizure.</Section>
      <Section>
        <Semibold>Increases in blood pressure (hypertension).</Semibold> Some people may get high blood pressure during treatment with AUVELITY. Your HCP should check your blood pressure before you start taking and during treatment with AUVELITY.</Section>
      <Section>
        <Semibold>Manic episodes.</Semibold> Manic episodes may happen in people with bipolar disorder who take AUVELITY. Symptoms may include:
      </Section>
      <Section tw="flex flex-col mt-2 md:(flex-row)">
        <DiscList isi={true} tw="mr-10">
          <li>greatly increased energy</li>
          <li>racing thoughts</li>
          <li>unusually grand ideas</li>
          <li>talking more or faster than usual</li>
        </DiscList>
        <DiscList isi={true}>
          <li>severe trouble sleeping </li>
          <li>reckless behavior</li>
          <li>excessive happiness or irritability</li>
        </DiscList>
      </Section>
      <Section>
        <Semibold>Unusual thoughts or behaviors.</Semibold> One of the ingredients in AUVELITY (bupropion) can cause unusual thoughts or behaviors, including delusions (believing you are someone else), hallucinations (seeing or hearing things that are not there), paranoia (feeling that people are against you), or feeling confused. If this happens to you, call your HCP.
      </Section>
      <Section>
        <Semibold>Eye problems (angle-closure glaucoma).</Semibold> AUVELITY may cause a type of eye problem called angle-closure glaucoma in people with certain other eye conditions. You may want to undergo an eye examination to see if you are at risk and receive preventative treatment if you are. Call your HCP if you have eye pain, changes in your vision, or swelling or redness in or around the eye.
      </Section>
      <Section>
        <Semibold>Dizziness.</Semibold> AUVELITY may cause dizziness which may increase your risk for falls.
      </Section>
      <Section>
        <Semibold>Serotonin syndrome.</Semibold> A potentially life-threatening problem called serotonin syndrome can happen when you take AUVELITY with certain other medicines.
        <Semibold tw="text-black">
          {" "}
          Call your HCP or go to the nearest hospital emergency room right away
        </Semibold>{" "}
        if you have any of the following signs and symptoms:
      </Section>
      <Section tw="flex flex-col mb-0 mt-2 md:(flex-row)">
        <DiscList isi={true} tw="mr-10">
          <li>agitation</li>
          <li>hallucinations</li>
          <li>confusion</li>
          <li>coma</li>
          <li>fast heartbeat</li>
          <li>blood pressure changes</li>
          <li>dizziness</li>
        </DiscList>
        <DiscList isi={true}>
          <li>sweating </li>
          <li>flushing</li>
          <li>high body temperature (hyperthermia)</li>
          <li>shaking (tremors), stiff muscles, or muscle twitching</li>
          <li>loss of coordination</li>
          <li>seizures</li>
          <li>nausea, vomiting, diarrhea</li>
        </DiscList>
      </Section>
      <Section>
        <Heading tw="mt-6 lg:mt-6">COMMON SIDE EFFECTS</Heading>
        <Semibold css={[BlackHeading]}>
          The most common side effects of AUVELITY include{" "}
        </Semibold>
        dizziness, headache, diarrhea, feeling sleepy, dry mouth, sexual function problems, and excessive sweating.
      </Section>
      <Section>
        These are not all the possible side effects of AUVELITY. Tell your doctor if you have any side effects.{" "}
          You are encouraged to report side effects of prescription drugs to the FDA. Visit{" "}
          <InlineLink
            removeTabIndex={removeTabIndex}
            href="http://www.fda.gov/medwatch"
            addClassForGTM="gtm-cta-click"
            onClick={e => {
              createExitModal(e)
            }}
            color="black"
          >
            www.fda.gov/medwatch
          </InlineLink>
          , or call{" "}
          <InlineLink
            removeTabIndex={removeTabIndex}
            href="tel:+18003321088"
            addClassForGTM="gtm-cta-click"
            color="black"
          >
            1&#8209;800&#8209;FDA&#8209;1088
          </InlineLink>
          .
      </Section>
      <Section>
        <Heading tw="mt-6 lg:mt-6">BEFORE USING</Heading>
        <DiscList isi={true}>
          <li>
            <Semibold css={[BlackHeading]}>
              {" "}
              Tell your HCP about all the medicines you take
            </Semibold>,{" "}
            including prescription and over-the-counter medicines, vitamins, and herbal supplements.
          </li>
          <li>
            <Semibold css={[BlackHeading]}>
              It is important to tell your HCP if you are taking:
            </Semibold>
          </li>
          <li tw="flex flex-col md:(flex-row)">
            <DiscList isi={true} sublist={true} tw="mr-10 md:width[50%]">
              <li>other medicines containing bupropion or dextromethorphan</li>
              <li>medicines to treat depression, anxiety, psychotic or thought disorders, including selective serotonin reuptake inhibitors (SSRIs) and tricyclic antidepressants</li>
              <li>theophylline</li>
              <li>corticosteroids</li>
            </DiscList>
            <DiscList isi={true} sublist={true}>
              <li>oral diabetes medicines or use insulin to control your blood sugar</li>
              <li>medicines to control appetite (anorectic)</li>
              <li>nicotine medicines to help you stop smoking</li>
              <li>street (illicit) drugs</li>
              <li>benzodiazepines, sedative-hypnotic (sleep medicines), or opiates</li>
            </DiscList>
          </li>
          <li>If you are unsure if you take any of these medicines, ask your HCP. They can tell you if it is safe to take AUVELITY with your other medicines.</li>
          <li>Tell your HCP if you are pregnant or plan to become pregnant. AUVELITY may harm your unborn baby if you take it during pregnancy. AUVELITY is not recommended during pregnancy. Your HCP will prescribe another treatment for females who plan to become pregnant.</li>
          <li>One of the ingredients in AUVELITY passes into your breast milk. Do not breastfeed during treatment with AUVELITY and for 5 days after the final dose.</li>
        </DiscList>
      </Section>
      <Section>
        <Semibold>
          Tell your HCP about all your medical conditions, including if you:{" "}
        </Semibold>
        <DiscList isi={true}>
          <li>have problems with your liver or kidneys.</li>
          <li>have diabetes, heart disease, or high blood pressure.</li>
          <li>have a history of seizure, stroke, eating disorder, head injury, or have a tumor in your brain or spinal cord.</li>
          <li>have a history of alcohol or drug abuse. </li>
          <li>have a history of seizure, eating disorder, or abuse alcohol or drugs.</li>
          <li>have low blood sugar, low blood sodium levels, or a history of falls.</li>
          <li>you take certain other medicines that could interact with AUVELITY.</li>
          <li>have or had a condition known as bipolar disorder, a family history of bipolar disorder, suicide, or depression.</li>
          <li>have high pressure in the eye (glaucoma). </li>
        </DiscList>
      </Section>
      <Section>
        <Semibold>Review the list below with your HCP. AUVELITY may not be right for you if:</Semibold>
        <DiscList isi={true}>
          <li>you drink a lot of alcohol.</li>
          <li>you abuse prescription or street drugs.</li>
          <li>you are pregnant or plan to become pregnant.</li>
          <li>you are breastfeeding or plan to breastfeed.</li>
        </DiscList>
      </Section>
      <Section>
        <Heading tw="mt-6 lg:mt-6">HOW TO TAKE</Heading>
        <DiscList isi={true}>
          <li>AUVELITY is available by prescription only.</li>
          <li>Take AUVELITY exactly as instructed by your HCP.</li>
          <li>Take AUVELITY 1 time a day for 3 days, then increase your dose to 2 times a day (taken at least 8 hours apart). Do not take more than 2 AUVELITY tablets in 24 hours.</li>
          <li>If you miss a dose, do not take an extra dose. Wait and take your next dose at the regular time. <strong>Do not</strong> take more than 1 dose of AUVELITY at a time.</li>
          <li>Do not change your dose or stop taking AUVELITY without talking to your HCP.</li>
          <li>Swallow AUVELITY tablets whole. Do not crush, chew, or divide the tablets.</li>
          <li>Do not give AUVELITY to other people.</li>
          <li>If you take too much AUVELITY call your poison control center at 1-800-222-1222 or go to the nearest hospital emergency room right away.</li>
        </DiscList>
      </Section>
      <Section>
        <Heading tw="mt-6 lg:mt-6">LEARN MORE</Heading>
        For more information about AUVELITY, call{" "}
        <a href="tel:8664962976">866-496-2976</a> or visit{" "}
        <span tw="text-black">AUVELITY.com</span>.
      </Section>
      <Section>This summary provides basic information about AUVELITY but does not include all information known about this medicine. Read the information that comes with your prescription each time your prescription is filled. This information does not take the place of talking with your doctor. Be sure to talk to your doctor or other HCP about AUVELITY and how to take it. Your HCP is the best person to help you decide if AUVELITY is right for you.</Section>
      <Section tw="text-blue">
        Please see full{" "}
        <InlineLink
          href="https://www.axsome.com/auvelity-prescribing-information.pdf"
          target="_blank"
          addClassForGTM="gtm-file-download gtm-cta-click fl-prescribing-info"
        >
          Prescribing Information
        </InlineLink>, including <Semibold>Boxed Warning</Semibold> for suicidal thoughts and behaviors, and{" "}
        <InlineLink
          href="https://www.axsome.com/auvelity-medication-guide.pdf"
          target="_blank"
          addClassForGTM="gtm-file-download gtm-cta-click fl-med-guide"
        >
          Medication Guide
        </InlineLink>
        .
      </Section>
      <Section>AUV CON BS 08/2024</Section>
    </>
  )
}
